import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.emailPeople || initialState;

export const selectEmailPeople = createSelector([selectSlice], state => state);

export const selectEmailPeopleLoadData = createSelector(
  [selectSlice],
  state => state.load,
);
